import { combineReducers } from 'redux'

import hotelReducer from './hotelReducer'
//import authReducer from './authReducer'
import profileReducer from './profileReducer'
import checkInReducer from './checkInReducer'
import requestsReducer from './requestsReducer'

const appReducer = combineReducers({
  hotelReducer,
  profileReducer,
  // authReducer,
  checkInReducer,
  requestsReducer
})

const rootReducer = (state, action) => {
    // when a logout action is dispatched it will reset redux state
    if (action.type === 'RESTART_DATA') {
      state = undefined;
    }
  
    return appReducer(state, action);
  };

export default rootReducer